import React, { memo, ReactElement } from 'react';
import { Button } from 'reactApp/ui/Button/Button';
import { UploadInput } from 'reactApp/ui/Mobile/UploadInput/UploadInput';

import styles from './SelectFromCloudEmpty.css';

export const SelectFromCloudEmpty = memo(function SelectFromCloudEmpty({ onClose }: { onClose(): void }): ReactElement {
    return (
        <div className={styles.empty}>
            <div className={styles.folder} />
            <span className={styles.title}>У вас пока нет фотографий</span>
            <span className={styles.text}>Загрузите фото или видео, чтобы добавить их в альбом</span>

            <Button 
                theme="vk" 
                primary 
                className={styles.button}
            >
                <div className={styles.upload}>
                    <UploadInput inputName="upload-from-gallery" onClick={onClose} />   
                </div>
                Загрузить с компьютера
            </Button>
        </div>
    );
});
